// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /event/last-played-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeEventLastPlayedGetBody,
  typeEventLastPlayedGetOutput200,
} from "../../sdk/event/postEventLastPlayedGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildEventLastPlayedGetQueryKey(
  payload: typeEventLastPlayedGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`leagueId:${JSON.stringify(payload.leagueId)}`);
  queryKeySegments.push(`timeZone:${JSON.stringify(payload.timeZone)}`);
  return [
    "post:event:eventLastPlayedGet",
    "svc:events-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeEventLastPlayedGetOutput200,
    unknown,
    typeEventLastPlayedGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useEventLastPlayedGet(
  payload: typeEventLastPlayedGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildEventLastPlayedGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postEventLastPlayedGet(payload),
    ...resolvedOptions,
  });
}
